import SettingsKey from 'app/profile/settings/utils/settingsTypes';
import { useSettingValue } from 'common/hooks/useSettingValue';
import * as moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { addAppointmentAction } from 'redux/slices/iCalendarV4';
import { closeNestedDialogAction } from 'redux/slices/nestedDialogSlice';
import { setNeedsToUpdate } from 'redux/slices/ocalendarSlice';
import AppointmentForm from './AppointmentForm';

const AppointmentCreate = (props) => {
    const { selectedDate, service } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const defaultLanguage = useSettingValue(SettingsKey.DEFAULT_LANGUAGE) || 'en';

    const appointment = useMemo(() => {
        return {
            title: '',
            description: '',
            startAt: selectedDate ? moment(selectedDate).set('second', 0).set('millisecond', 0) : '',
            endAt: selectedDate ? moment(selectedDate).set('second', 0).set('millisecond', 0).add(30, 'minutes') : '',
            calendarIds: [],
            status: '',
            subStatus: '',
            comment: '',
            serviceId: service?.id ?? '',
            extraFields: {},
            origin: '',
            lang: defaultLanguage,
        };
    }, [selectedDate, defaultLanguage, service]);

    const handleSubmit = (payload, callbackOk, callbackError) => {
        dispatch(
            addAppointmentAction({
                appointmentDto: {
                    ...payload,
                    allowOverlapping: true,
                },
                onSuccess: (taskResult) => {
                    callbackOk(taskResult);
                    dispatch(setNeedsToUpdate(true));
                    dispatch(closeCustomDialogAction());
                    dispatch(closeNestedDialogAction());
                },
                onFailure: (taskResult) => {
                    callbackError(taskResult);
                },
            }),
        );
    };

    return (
        <AppointmentForm
            appointment={appointment}
            onSubmit={handleSubmit}
            action={t('appointment.form.createTitle')}
            service={service}
        />
    );
};

export default AppointmentCreate;
